<script setup lang="ts">
import { useMenuButton, type MenuButtonProps } from '../../composables/button/useMenuButton'
import { useDialogMessage } from '../../messages/useDialogMessage'

const props = defineProps<MenuButtonProps>()

const { id, image, target, disabled } = useMenuButton(props)
const message = useDialogMessage(id)

function handleMenuPointerDown() {
  if (!disabled.value) {
    message.OpenDialogCommand(target)
  }
}
</script>

<template>
  <button :id class="menu-button" :disabled @pointerdown="handleMenuPointerDown">
    <img class="hilight" :src="image.hilight" />
    <img :src="image.menu" />
  </button>
</template>

<style scoped>
/* ------------------------ */
.menu-button {
  position: absolute;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
}

.menu-button .hilight {
  position: absolute;
}

.menu-button:disabled {
  cursor: auto;
}

.menu-button:disabled .hilight {
  visibility: hidden;
}

/* ------------------------ */
.menu-button.blink1 .hilight {
  opacity: 0;
  animation: fade-in-out1 4s ease-in-out infinite;
}
/* prettier-ignore */
@keyframes fade-in-out1 {
  0% { opacity: 0; }
  25% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 0; }
}

/* ------------------------ */
.menu-button.blink2 .hilight {
  opacity: 0;
  animation: fade-in-out2 4s ease-in-out infinite;
}
/* prettier-ignore */
@keyframes fade-in-out2 {
  0% { opacity: 0; }
  50% { opacity: 0; }
  75% { opacity: 1; }
  100% { opacity: 0; }
}
/* ------------------------ */
</style>
